import "./Navbar.css";
import "./ResponsiveNavbar.css";
import logo from "./logo.jpg";
import { NavLink, Route, Routes } from "react-router-dom";
import { getTranslatedText as translate } from "../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { useEffect } from "react";
import { useLocation } from "react-router";
import LanguageSelection from "../LanguageSelection/LanguageSelect.js";
import Website from "../Website/Website.js";
import AccountantWebPage from "../Accountant/AccountantWebPage";
import LaundromatsWebPage from "../LaundryOwners/LaundromatsWebPage";
import DeliveryRepresentatives from "../DeliveryRepresentatives/DeliveryRepresentatives";
import Statistics from "../MainJoinRequests/Statistics/Statistics";

const clickHamburger = () => {
  const hamburger = document.querySelector(".hamburger");
  const navMenu = document.querySelector(".nav-buttons");

  hamburger.classList.toggle("active");
  navMenu.classList.toggle("active");
};
function clickTab(newClassName) {
  var newTab = document.querySelector(newClassName);
  Array.from(document.querySelectorAll(".nav-button")).forEach(function (val) {
    if (!val.classList.contains(newClassName)) {
      val.style.fontWeight = "normal";
      val.style.borderBottom = "none";
    }
  });
  newTab.style.fontWeight = "bold";
  newTab.style.borderBottom = "solid 1px";

  const hamburger = document.querySelector(".hamburger");
  const navMenu = document.querySelector(".nav-buttons");
  hamburger.classList.remove("active");
  navMenu.classList.remove("active");
}

const onMouseOverUserName = () => {
  document.querySelector(".log-out-btn").style.visibility = "visible";
};

const onMouseLeaveUserName = () => {
  document.querySelector(".log-out-btn").style.visibility = "hidden";
};

function Navbar() {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/Navbar/LaundryOwners", 0))
      clickTab(".LaundryOwners-nav-tab");
    else if (location.pathname.startsWith("/Navbar/DeliveryRepresentatives", 0))
      clickTab(".DeliveryRepresentatives-nav-tab");
    else if (location.pathname.startsWith("/Navbar/Accountant", 0))
      clickTab(".Accountant-nav-tab");
    else if (location.pathname.startsWith("/Navbar/JoinRequests", 0))
      clickTab(".JoinRequests-nav-tab");
    else if (location.pathname.startsWith("/Navbar/Statistics", 0))
      clickTab(".Statistics-nav-tab");
  }, []);

  return (
    <div
      className="Navbar"
      dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
    >
      <div className="nav-box-container">
        <div className="nav-container">
          <div className="hamburger" onClick={clickHamburger}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>

          <div className="name-lang-nav">
            {/* Switch Language */}
            <LanguageSelection />

            <div
              onMouseOver={onMouseOverUserName}
              onMouseDown={onMouseLeaveUserName}
            >
              <span className="current-user-navbar">
                <i className="bi bi-person-circle"></i>
                {translate("admin-name", locale)}
                <i className="bi bi-caret-down-fill"></i>
              </span>
              <span className="log-out-btn">
                {translate("logout", locale)}
                <i className="bi bi-box-arrow-left"></i>
              </span>
            </div>
          </div>

          <div className="nav-buttons d-flex justify-content-between row">
            {/* Tabs */}
            <NavLink
              to="/Navbar/Statistics"
              className="Statistics-nav-tab nav-button current-tab nav-link-navbar col-1"
              onClick={() => clickTab(".Statistics-nav-tab")}
            >
              <span>{translate("statistics-main-tab", locale)}</span>
            </NavLink>
            <NavLink
              to="/Navbar/JoinRequests/delivery"
              className="JoinRequests-nav-tab nav-button nav-link-navbar col-1"
              onClick={() => clickTab(".JoinRequests-nav-tab")}
            >
              <span>{translate("joins-requests-main-tab", locale)}</span>
            </NavLink>
            <NavLink
              to="/Navbar/LaundryOwners/AllLaundromats"
              className="LaundryOwners-nav-tab nav-button nav-link-navbar col-1"
              onClick={() => clickTab(".LaundryOwners-nav-tab")}
            >
              <span>{translate("laundry-owners-tab", locale)}</span>
            </NavLink>
            <NavLink
              to="/Navbar/DeliveryRepresentatives"
              className="DeliveryRepresentatives-nav-tab nav-button nav-link-navbar col-1"
              onClick={() => clickTab(".DeliveryRepresentatives-nav-tab")}
            >
              <span>{translate("Delivery-representatives-tab", locale)}</span>
            </NavLink>
            <NavLink
              to="/Navbar/Accountant/Fees"
              className="Accountant-nav-tab nav-button nav-link-navbar col-1"
              onClick={() => clickTab(".Accountant-nav-tab")}
            >
              <span>{translate("Accountant-account-tab", locale)}</span>
            </NavLink>

            {/* Logo */}
            <div className="nav-logo" dir="auto">
              <img src={logo} className="nav-logo-picture" />
            </div>
          </div>
        </div>
      </div>

      <Routes>
        {/* <Route path='Home/*' element={<Website />} /> */}
        <Route path="Statistics/*" element={<Statistics />} />
        <Route path="JoinRequests/*" element={<Website />} />
        <Route path="LaundryOwners/*" element={<LaundromatsWebPage />} />
        <Route
          path="DeliveryRepresentatives/*"
          element={<DeliveryRepresentatives />}
        />
        <Route path="Accountant/*" element={<AccountantWebPage />} />
      </Routes>
    </div>
  );
}

export default Navbar;
